import * as React from "react";
import { Dispatch } from "redux";
import { Link, Routes } from "react-router-dom";
import { connect } from "react-redux";
import { GetCredentialsAsyncAction } from "./Administration/AdministrationActions";
import { MainState } from "../Core/reducers";
import { } from "react-router-dom";
import { ReportViewer } from "./ReportViewer";
import LoadingWithMessage from "../misc/components/LoadingWithMessage";
import Alert, { AlertCategoryEnum } from "../misc/components/Alert";
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";
import { useParams, useLocation, useNavigate, type Location } from "react-router-dom";

declare const rootUrl: string;

interface ReportViewerScreenRouteProps {
    path: string;
}

interface ReportViewerScreenOwnProps {
    reportServerURL: string;
}

interface LocationRouteProps {
    id: string;
}

export type ReportViewerScreenProps = ReportViewerScreenOwnProps & {
    dispatch: Dispatch<MainState>
};

interface ReportViewerScreenState {
    userId: string;
    sessionId: string;
    fetched: boolean;
    parameters: any;
}

export const ReportViewerScreen = (props: ReportViewerScreenProps) => {
    const [userId, setUserId] = React.useState(null);
    const [sessionId, setSessionId] = React.useState(null);
    const [fetched, setFetched] = React.useState(null);
    const [parameters, setParameters] = React.useState(null);
    const legacyClient = useWebPortalLegacyClient();
    const location = useLocation();
    const { id } = location.state || {};
    const { path } = useParams<{ path: string }>();

    React.useEffect(() => {
        const load = async () => {
            await fetchParameters();
            await createReportServerSession();
        }

        load();
    }, []);

    const createReportServerSession = async () => {
        setFetched(null);

        props.dispatch(GetCredentialsAsyncAction.create(legacyClient));
        try {
            const response = await legacyClient.createReportSession()
            if (response.ok) {
                const authentication = await response.json();
                setUserId(authentication.User);
                setSessionId(authentication.Session);
                setFetched(true);
            }
            else {
                setFetched(false);
            }
        }
        catch {
            throw Error("Failed to authenticate with the report server");
        }
    }

    const fetchParameters = async () => {
        
        try {
            const parametersResult = await legacyClient.getDefinedReportParameters(id);

            setParameters(parametersResult);
        }
        catch {
            throw Error("Failed to fetch parameters");
        }
    }

    const renderViewerWrapper = () => {
        if (fetched && props.reportServerURL) {
            if (sessionId) {
                return (
                    <ReportViewer
                        reportServerUri={props.reportServerURL}
                        reportPath={path}
                        sessionId={sessionId}
                        parameters={parameters}
                        minHeight={500}
                    />
                );
            }
        } else if (fetched === false) {
            return (
                <Alert show={true} category={AlertCategoryEnum.Danger}>
                    Failed to connect to Report Server. The Report cannot be loaded. <a onClick={() => createReportServerSession()}>Retry Connection</a>
                </Alert>
            );
        } else {
            return <LoadingWithMessage message="Loading Report..." />;
        }
    }

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Report View</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-center">
                    {renderViewerWrapper()}      
                </div>
            </div>
            <div className="col-md-12 pull-right h2">
                <Link className="btn btn-primary pull-right" to="/Reports">
                    Return to List
                </Link>
            </div>
        </>
    );
}

function mapStateToProps(state: MainState): ReportViewerScreenOwnProps {
    return {
        reportServerURL: state.reports.administration.credentials
            ? state.reports.administration.credentials.ServerURL
            : null
    };
}

export default connect(mapStateToProps)(ReportViewerScreen);
